export const reglas = [


    {
        "titulo" :"Creación de Equipos"  , 
        "texto" : "Para la formación de los equipos, se tomará en consideración el promedio de los atributos de pase, tiro, verticalidad, ritmo, defensa y portería del equipo en general, en lugar del promedio de los jugadores. Si algún jugador considera injusta la asignación de los equipos, puede presentar una queja justificada para la creación de nuevos equipos."
    },

    {
        "titulo" : "Partido" , 
        "texto" : "El partido consta de tres partes, cada una con una duración de 30 minutos, y se realizará un descanso de 10 minutos entre cada parte. En caso de que el tiempo establecido se agote y haya una jugada en curso, se permitirá que dicha jugada se complete antes de finalizar el partido."
    },

    {
        "titulo" : "Faltas"  , 
        "texto" :"Los jugadores amonestados con tarjeta amarilla recibirán una penalización de 2 minutos fuera del campo de juego. Si un jugador acumula tres tarjetas amarillas, se le mostrará una tarjeta roja, lo que resultará en una penalización de 5 minutos fuera del campo de juego." 
    },

    {
        "titulo" : "Puntuación"  , 
        "texto" : "En términos de puntuación, la victoria en un partido otorgará 4 puntos al equipo ganador. En caso de empate, cada equipo recibirá 2 puntos. En cuanto al rendimiento individual, marcar un gol otorgará 0.5 puntos y proporcionar una asistencia otorgará 0.25 puntos."
    },
    {
        "titulo" :"Penalización"  , 
        "texto" : "En caso de que un jugador priorice egoístamente su puntuación individual por encima del juego en equipo y el 60% o más de los miembros del equipo presenten una queja ante el árbitro, este tendrá la autoridad para penalizar al jugador con una deducción de 2 puntos."
    },

    {
        "titulo" :"Premios"  , 
        "texto" : "Se entregarán tres premios en la liga: 1. Balón de Oro: Será otorgado al jugador con la mayor puntuación en la liga. 2. Medalla de Oro: Será otorgada al jugador con la mayor cantidad de goles en la liga. 3. Medalla de Plata: Será otorgada al jugador con la mayor cantidad de asistencias en la liga. Es importante destacar que ningún jugador puede recibir más de un premio. En caso de que el ganador de una categoría ya haya recibido un premio, este premio se otorgará al siguiente jugador consecutivo en esa categoría."
       
    },

    {
        "titulo" : "Inscripción" , 
        "texto" :"El costo de la inscripción es de 4 euros." 
    }


]